import actionTypes from "constants/layout";
import { Action, ActionFunctionAny, createActions } from "redux-actions";

const { TOGGLE_FULLSCREEN, TOGGLE_THEME, TOGGLE_SIDEBAR, PUT_DATA, CLEAR_DATA } = actionTypes;

const actions = createActions(TOGGLE_FULLSCREEN, TOGGLE_THEME, TOGGLE_SIDEBAR, PUT_DATA, CLEAR_DATA);

const toggleFullscreen = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.toggleFullscreen());

const toggleTheme = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.toggleTheme());

const toggleSidebar = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.toggleSidebar(params));

const putData = (data: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.putData(data));

const clearData = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.clearData());

export default { ...actions, toggleFullscreen, toggleTheme, toggleSidebar, putData, clearData };
